import { useWmsGetLegend } from "@nens/ldo/api-v1";
import { RasterStyle } from "@nens/lizard/api-v4";

import { GradientLegend } from "./gradient-legend";

interface RasterLegendProps {
  layer: string;
  rasterStyle: RasterStyle;
  setRasterStyle: (style: string | null) => void;
}

export function RasterLegend({ layer, rasterStyle, setRasterStyle }: RasterLegendProps) {
  const legendResponse = useWmsGetLegend(layer, rasterStyle.toString());

  if (!legendResponse.isSuccess) {
    return null;
  }

  const { colormap_type, legend } = legendResponse.data;

  if (colormap_type !== "gradient") {
    return null;
  }

  return (
    <GradientLegend
      legend={legend}
      isHorizontal
      uniqueId={layer + rasterStyle.toString()}
      currentRasterStyle={rasterStyle}
      setRasterStyleString={setRasterStyle}
    />
  );
}
